import { memo } from "react";
import Nav from 'react-bootstrap/Nav';

import { ReportTabType } from 'types/Reports';

type ReportTabProps = {
    showTabs: ReportTabType[];

    activeTab: ReportTabType;

    handleSwitchTab: (tab: ReportTabType) => any;
};

export default memo(function ReportTab({
    showTabs,
    activeTab,
    handleSwitchTab,
}: Readonly<ReportTabProps>) {
    if (!showTabs || showTabs.length === 0) {
        return <></>;
    }

    return (
        <Nav
            activeKey={activeTab}
            onSelect={(selectedKey) => handleSwitchTab(selectedKey as ReportTabType)}
            className='report-tab'
        >
            {showTabs.includes('overview') ? <Nav.Item>
                <Nav.Link eventKey="overview">Overview</Nav.Link>
            </Nav.Item> : <></>}

            {showTabs.includes('room') ? <Nav.Item>
                <Nav.Link eventKey="room">Rooms</Nav.Link>
            </Nav.Item> : <></>}

            {showTabs.includes('utilities') ? <Nav.Item>
                <Nav.Link eventKey="utilities">Utilities</Nav.Link>
            </Nav.Item> : <></>}

            {showTabs.includes('environment') ? <Nav.Item>
                <Nav.Link eventKey="environment">Environment</Nav.Link>
            </Nav.Item> : <></> }

            {showTabs.includes('air_quality') ? <Nav.Item>
                <Nav.Link eventKey="air_quality">Air Quality</Nav.Link>
            </Nav.Item> : <></> }
        </Nav>
    );
});
